import {createContext} from "react";

export type IndustrialLocation = {
	id: number;
	id_report: number;
	date_added: number;
	date_modified: number;
	id_star_system: number;
	id_planet: number;
	id_orbit: number;
	id_space_station: number;
	id_terminal: number;
	id_city: number;
	id_moon: number;
	id_outpost: number;
	id_poi: number;
	star_system_name: string | null;
	planet_name: string | null;
	orbit_name: string | null;
	space_station_name: string | null;
	terminal_name: string | null;
	city_name: string | null;
	moon_name: string | null;
	outpost_name: string | null;
	poi_name: string | null;
	value: number;
	value_week: number;
	value_month: number;
};

export interface iIndustrialJob {
	id: string,
	location: string,
	title: string,
	note?: string,
	material: string,
	amount: number,
	timestamp: Date,
	durationInMinutes: number
}

export interface iMaterial {
	id: string,
	name: string,
	category: string,
	method: string,
	refinable: boolean
}

interface iIndustrialTasks {
	locations: IndustrialLocation[],
	materials: iMaterial[],
	jobs: iIndustrialJob[],
	inProgress: iIndustrialJob[],
	completedTasks: iIndustrialJob[],
	Actions: {
		createJob: ( job: iIndustrialJob ) => void,
		clearJobs: ( id: string ) => void
	}
}

export const defaultValues = {
	locations: [],
	materials: [],
	jobs: [],
	inProgress: [],
	completedTasks: [],
	Actions: {
		createJob: () => {},
		clearJobs: () => {}
	}
}

export const IndustrialTasksContext = createContext< iIndustrialTasks >( defaultValues )